/** Shared rules for file-backed image subjects and map ownership. */
export function hasImageSubjectData(subject: { summary?: unknown; values?: unknown; fields?: unknown }): boolean {
  const meaningful = (value: unknown): boolean => typeof value === 'string' ? !!value.trim() : Array.isArray(value) ? value.some(meaningful) : !!value && typeof value === 'object' ? Object.entries(value).some(([key, item]) => !/^(id|image.*|.*image|.*url|.*asset.*|createdAt|updatedAt|status|enabled|visibleToPlayers|pinned|revision)$/i.test(key) && meaningful(item)) : false;
  return meaningful(subject.summary) || meaningful(subject.values ?? subject.fields);
}

export function requireImageSubjectData(subject: Parameters<typeof hasImageSubjectData>[0]): void {
  if (!hasImageSubjectData(subject)) throw new Error('เพิ่มคำอธิบายหรือข้อมูลในไฟล์ก่อนสร้างภาพ เพื่อให้โมเดลอ่านบริบทจริงของไฟล์');
}

export function resolveImageStyle(specific?: string, overall?: string): string {
  return specific?.trim() || overall?.trim() || '';
}

export function isLocationFileType(category: { name?: string }, template?: { designation?: string; name?: string }): boolean {
  if (template?.designation === 'location') return true;
  const name = `${category.name || ''} ${template?.designation || ''} ${template?.name || ''}`;
  if (/memory|event|lore|history|timeline|\blog\b|state|tracker/i.test(name)) return false;
  return /location|place|map|world|universe|region|city|town|village|dungeon|building|shop|store|tavern|\bbar\b|point.of.interest|establishment|star.system|dimension|marine.zone|สถานที่|พื้นที่|แผนที่|โลก|จักรวาล|เมือง|หมู่บ้าน|ดันเจี้ยน|อาคาร|ร้าน|บาร์/i.test(name);
}
